import React from 'react';
import FormikInput, { FormikInputProps } from './FormikInput';

export function FormikInputCurrency<T>({ ...props }: FormikInputProps): any {
  return <FormikInput<T> {...props} useCurrencyMask />;
}

export default FormikInputCurrency;
